export default "__VITE_ASSET__DkLslTNz__"